export default "__VITE_PUBLIC_ASSET__5f2b4bf6__"